import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { timeSlotsList } from "constants/techncianAvailabilty";

//get technician availability detail by id
export const getTechncianAvailablityByID = async (id) => {
  try {
    const res = await api.get_technician_availability_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
export const addTechnicianAvaiability = async (bodyData) => {
  try {
    const res = await api.add_technician_availability(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//get time slots  list
export const getTimeSlotsList = async (dispatch) => {
  try {
    const res = await api.get_timeSlots_list();
    dispatch({ type: timeSlotsList, payload: res.data });
  } catch (error) {
    dispatch({ type: timeSlotsList, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};
